import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { AuthService } from '../../shared/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.sass'],
})
export class ResetPasswordComponent implements OnInit {
  token = '';
  newPassword = '';
  confirmPassword = '';
  loading = false;
  showNew = false;
  showConfirm = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'] || '';
    });

    if (!this.token) {
      this.toastService.showWarn('Link inválido ou expirado. Solicite uma nova recuperação de senha.');
      this.router.navigate(['/recuperar-senha']);
    }
  }

  get passwordsMatch(): boolean {
    return this.newPassword === this.confirmPassword;
  }

  get isFormValid(): boolean {
    return (
      !!this.token &&
      this.newPassword.length >= 6 &&
      this.passwordsMatch
    );
  }

  onSubmit() {
    if (!this.isFormValid) {
      if (this.newPassword.length < 6) {
        this.toastService.showWarn('A senha deve ter pelo menos 6 caracteres.');
        return;
      }
      if (!this.passwordsMatch) {
        this.toastService.showWarn('As senhas não conferem.');
        return;
      }
      return;
    }

    this.loading = true;
    this.authService.resetPassword(this.token, this.newPassword).subscribe({
      next: () => {
        this.loading = false;
        this.toastService.showSuccess('Senha redefinida com sucesso! Faça login com sua nova senha.');
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.loading = false;
        const msg = err?.error?.message || 'Erro ao redefinir a senha. O link pode ter expirado.';
        this.toastService.showError(msg);
      },
    });
  }
}
